module.exports = __webpack_public_path__ + "img/page1@2x.60ccb122.png";